export default __webpack_public_path__ + "static/media/footer_mobile.a140e6bd.jpg";